import { AddDataForm, AddDataResponse } from "../../../../contentManager/Panels/CMAddDatasourceItemPanel";
import { IDatasourceRequestDto } from "../../interfaces/DatasourceRequestDto";
import { dataSourceItem } from "../../redux/models/reduxModels";
import { DatasourceService } from "../../services/DatasourceService";
import { DatasourceFieldHelper } from "./dataSourceFieldHelper";

export class DatasourceHelper {
  constructor(private datasourceService: DatasourceService) { }

  async getSearchStructure(item: dataSourceItem) {
    if (item) {
      const request: IDatasourceRequestDto = {
        id: item.id,
        tenantId: item.tenantId,
        typeId: item.type.id,
        typeName: item.type.name,
        name: item.name,
        allowCache: item.allowCache
      };

      return await this.datasourceService.GetStructure(request);
    }

    return [];
  }

  async getEditStructure(item: dataSourceItem): Promise<AddDataResponse[]> {
    if (item) {
      const request: IDatasourceRequestDto = {
        id: item.id,
        tenantId: item.tenantId,
        typeId: item.type.id,
        typeName: item.type.name,
        name: item.name
      };

      return await this.datasourceService.GetEditStructure(request);
    }

    return [];
  }

  async addItem(item: dataSourceItem, data: AddDataForm[]) {
    if (item) {
      const request: IDatasourceRequestDto = {
        id: item.id,
        tenantId: item.tenantId,
        typeId: item.type.id,
        typeName: item.type.name,
        name: item.name
      };

      return await this.datasourceService.GetEditStructure(request);
    }

    return [];
  }

  getInputDataSource = (items: dataSourceItem[], displayName: string, selectedSites: string[], selectedLibraries: string[]) => {
    const dsItem = items
      .filter(item => DatasourceFieldHelper.checkDatasourceAllowed(selectedSites, selectedLibraries, item))
      .find(source =>
        source.boundFields.some(bound => {
          const val = bound.name?.split(',').some(name => name.trim().toLowerCase() === displayName?.trim().toLowerCase());
          return val;
        })
      );
    return dsItem;
  };

  updateSearchInputs(index: number, value: string, inputsToCopy: any[], statePropToUpdate: any) {
    if (index >= 0 && index < inputsToCopy.length) {
      const copiedInputs = [...inputsToCopy];
      copiedInputs[index].value = value;
      statePropToUpdate(copiedInputs);
    }
  }

  getBoundedField(datasource: dataSourceItem, displayName: string) {
    const boundedField = datasource?.boundFields.find(item => item.name?.split(",").some(name => name.trim().toLowerCase() === displayName.trim().toLowerCase()));
    return boundedField?.datasourceField ? boundedField.datasourceField.trim() : boundedField?.name?.trim();
  }
}